import { func, number } from 'prop-types';
import { isNil } from 'ramda';
import { useState } from 'react';

import { TimeFormat, TIME_PATTERNS, timeFormatPattern } from '../TimeFormat';
import { useInterval } from './utils';
/**
 * Component that displays time counter in hours:minutes AM/PM format
 * Can also receive render children
 */
const UPDATE_INTERVAL = 1000; // ms

const roundToZero = (ms) => (ms > 0 ? Math.floor : Math.ceil);

const parseMs = (ms) => ({
  hours: roundToZero(ms)((ms / 3600000) % 24),
  minutes: roundToZero(ms)((ms / 60000) % 60),
  seconds: roundToZero(ms)((ms / 1000) % 60),
});

const getStep = (start, end, ms) => (isNil(end) || start <= end ? ms + UPDATE_INTERVAL : ms - UPDATE_INTERVAL);

const Timer = ({ format, start, end, callback, children, ...props }) => {
  const [ milliseconds, setMilliseconds ] = useState(start * UPDATE_INTERVAL);
  let interval;

  const setCounter = () => {
    const nextStep = getStep(start, end, milliseconds);

    if (!isNil(end) && nextStep === end * UPDATE_INTERVAL) {
      callback();
      interval.clear();
    }

    setMilliseconds(nextStep);
  };

  interval = useInterval(setCounter, UPDATE_INTERVAL);

  return (
    <TimeFormat {...{ time: parseMs(milliseconds), milliseconds, format }} {...props}>
      {children}
    </TimeFormat>
  );
};

Timer.propTypes = {
  format: timeFormatPattern,
  start: number,
  end: number,
  callback: func,
};

Timer.defaultProps = {
  start: 0,
  format: `${TIME_PATTERNS.HOURS}:${TIME_PATTERNS.MINUTES}:${TIME_PATTERNS.SECONDS}`,
  callback: () => {},
};

export default Timer;
